import React from "react";
import { Field, ErrorMessage } from "formik";
import { FaFilePdf } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Step4 = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-6 bg-[#F6FBFF] mb-6">
      {/* Previous Projects (PDF) */}
      <div className="col-span-2">
        <label className="block text-xs font-semibold text-gray-700 mb-1 flex items-center gap-1">
          {t("contractorSignup.form.step4.previousProjectsLabel", "Previous Projects")}
          <span className="text-red-500">*</span>
        </label>
        <Field name="previous_projects">
          {({ form, field }) => (
            <div>
              <input
                type="file"
                accept=".pdf"
                onChange={(event) => {
                  form.setFieldValue("previous_projects", event.currentTarget.files[0]);
                }}
                className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm focus:border-green-500 focus:outline-none transition"
              />
              <ErrorMessage
                name="previous_projects"
                component="div"
                className="text-red-500 text-xs mt-1"
              />
              <div className="mt-2 text-xs text-gray-600 flex gap-2 flex-wrap">
                {field.value ? (
                  <span className="flex items-center gap-1">
                    <FaFilePdf className="text-red-600" />
                    {field.value.name}
                  </span>
                ) : (
                  <span>{t("contractorSignup.form.noFileUploaded", "No file uploaded.")}</span>
                )}
              </div>
            </div>
          )}
        </Field>
      </div>
      {/* Client Testimonials (PDF) */}
      <div className="col-span-2">
        <label className="block text-xs font-semibold text-gray-700 mb-1 flex items-center gap-1">
          {t("contractorSignup.form.step4.clientTestimonialsLabel", "Client Testimonials")}
          <span className="text-red-500">*</span>
        </label>
        <Field name="client_testimonials">
          {({ form, field }) => (
            <div>
              <input
                type="file"
                accept=".pdf"
                onChange={(event) => {
                  form.setFieldValue("client_testimonials", event.currentTarget.files[0]);
                }}
                className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm focus:border-green-500 focus:outline-none transition"
              />
              <ErrorMessage
                name="client_testimonials"
                component="div"
                className="text-red-500 text-xs mt-1"
              />
              <div className="mt-2 text-xs text-gray-600 flex gap-2 flex-wrap">
                {field.value ? (
                  <span className="flex items-center gap-1">
                    <FaFilePdf className="text-red-600" />
                    {field.value.name}
                  </span>
                ) : (
                  <span>{t("contractorSignup.form.noFileUploaded", "No file uploaded.")}</span>
                )}
              </div>
            </div>
          )}
        </Field>
      </div>
      {/* Preferred Invoicing Schedule (Dropdown) */}
      <div>
        <label
          htmlFor="invoicing_schedule"
          className="block text-xs font-semibold text-gray-700 mb-1 flex items-center gap-1"
        >
          {t(
            "contractorSignup.form.step4.preferredInvoicingScheduleLabel",
            "Preferred Invoicing Schedule",
          )}
          <span className="text-red-500">*</span>
        </label>
        <Field
          as="select"
          id="invoicing_schedule"
          name="invoicing_schedule"
          className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm focus:border-green-500 focus:outline-none transition"
        >
          <option value="">
            {t("contractorSignup.form.step4.invoicingSchedulePlaceholder", "Select Schedule")}
          </option>
          <option value="monthly">
            {t("contractorSignup.form.step4.invoicingScheduleOptions.monthly", "Monthly")}
          </option>
          <option value="quarterly">
            {t("contractorSignup.form.step4.invoicingScheduleOptions.quarterly", "Quarterly")}
          </option>
          <option value="upon_completion">
            {t(
              "contractorSignup.form.step4.invoicingScheduleOptions.uponCompletion",
              "Upon Completion",
            )}
          </option>
        </Field>
        <ErrorMessage
          name="invoicing_schedule"
          component="div"
          className="text-red-500 text-xs mt-1"
        />
      </div>
      {/* Payment Terms (Dropdown) */}
      <div>
        <label
          htmlFor="payment_terms"
          className="block text-xs font-semibold text-gray-700 mb-1 flex items-center gap-1"
        >
          {t("contractorSignup.form.step4.paymentTermsLabel", "Payment Terms")}
          <span className="text-red-500">*</span>
        </label>
        <Field
          as="select"
          id="payment_terms"
          name="payment_terms"
          className="bg-[#F1F6F9] border border-gray-300 rounded px-2 py-1 w-full text-sm focus:border-green-500 focus:outline-none transition"
        >
          <option value="">
            {t("contractorSignup.form.step4.paymentTermsPlaceholder", "Select Terms")}
          </option>
          <option value="net_15">
            {t("contractorSignup.form.step4.paymentTermsOptions.net15", "Net 15")}
          </option>
          <option value="net_30">
            {t("contractorSignup.form.step4.paymentTermsOptions.net30", "Net 30")}
          </option>
          <option value="net_60">
            {t("contractorSignup.form.step4.paymentTermsOptions.net60", "Net 60")}
          </option>
          <option value="advance">
            {t("contractorSignup.form.step4.paymentTermsOptions.advance", "Advance")}
          </option>
        </Field>
        <ErrorMessage name="payment_terms" component="div" className="text-red-500 text-xs mt-1" />
      </div>
    </div>
  );
};

export default Step4;
